import { clientUrl } from "global";

export class Api {


    constructor() {

    }

    public static fetchApiCall(_url: string, token: string, successAction: string, errorAction: string,) {
        return {
            url: _url,
            successAction: successAction,
            errorAction: errorAction,
            params: this.getFetchAPIParams(token),
            closeModal: false,
        };
    }

    static getFetchAPIParams(token: string): RequestInit {
        return {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            headers: Api.getHeaders(token),
            referrerPolicy: 'origin',
        }
    };

    public static postApiCall(_url: string, token: string, successAction: string, errorAction: string, payload: object | string, emitSuccessMessage?: boolean) {
        return {
            url: _url,
            successAction: successAction,
            errorAction: errorAction,
            params: this.getPostAPIParams(token, payload),
            closeModal: true,
            emitSuccessMessage: emitSuccessMessage
        };
    }

    static getPostAPIParams(token: string, object: object | string): RequestInit {
        return {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: Api.getHeaders(token),
            referrerPolicy: 'origin',
            body: JSON.stringify(object)
        }
    };

    public static putApiCall(_url: string, token: string, successAction: string, errorAction: string, payload: object, emitSuccessMessage?: boolean) {
        return {
            url: _url,
            successAction: successAction,
            errorAction: errorAction,
            params: this.getPutAPIParams(token, payload),
            closeModal: true,
            emitSuccessMessage: emitSuccessMessage
        };
    }

    static getPutAPIParams(token: string, payload: object): RequestInit {
        return {
            method: 'PUT',
            mode: 'cors',
            cache: 'no-cache',
            headers: Api.getHeaders(token),
            referrerPolicy: 'origin',
            body: JSON.stringify(payload)
        }
    };
    public static deleteApiCall(_url: string, token: string, successAction: string, errorAction: string, emitSuccessMessage?: boolean) {
        return {
            url: _url,
            successAction: successAction,
            errorAction: errorAction,
            params: this.getDeleteAPIParams(token),
            closeModal: false,
            emitSuccessMessage: emitSuccessMessage
        };
    }

    static getDeleteAPIParams(token: string): RequestInit {
        return {
            method: 'DELETE',
            mode: 'cors',
            cache: 'no-cache',
            headers: Api.getHeaders(token),
            referrerPolicy: 'origin'
        }
    };

    static getHeaders(token?: string): HeadersInit {
        return token ? {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
            'Access-Control-Allow-Origin': JSON.stringify(clientUrl)
        } : {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': JSON.stringify(clientUrl)
        }
    }
}